import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Moon, Clock } from 'lucide-react';
export function IncludesSection() {
  const items = [{
    icon: <FileText className="w-6 h-6" data-id="element-61" />,
    title: 'La guía completa',
    desc: 'Apaga la Ansiedad Nocturna (PDF)'
  }, {
    icon: <Moon className="w-6 h-6" data-id="element-62" />,
    title: 'Protocolo paso a paso',
    desc: 'Explicación detallada del Ritual 10-10-10'
  }, {
    icon: <Clock className="w-6 h-6" data-id="element-63" />,
    title: 'Versión de emergencia',
    desc: 'Variante de 2 minutos para noches muy pesadas'
  }];
  return <section className="py-24 px-6 bg-[#111827]" data-id="element-64">
      <div className="max-w-4xl mx-auto" data-id="element-65">
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-66">
          <h2 className="text-3xl font-bold text-[#f5efe3] mb-4" data-id="element-67">
            Qué incluye (exactamente)
          </h2>
          <p className="text-[#8b9bb4]" data-id="element-68">
            Todo lo que necesitas para cerrar tu día hoy mismo.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-69">
          {items.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex items-start gap-4 p-6 bg-[#0c1220] rounded-xl border border-white/5" data-id="element-70">
              <div className="w-12 h-12 rounded-full bg-[#c9956b]/10 flex items-center justify-center text-[#c9956b] shrink-0" data-id="element-71">
                {item.icon}
              </div>
              <div data-id="element-72">
                <h3 className="font-bold text-[#f0e6d3] mb-1" data-id="element-73">{item.title}</h3>
                <p className="text-[#8b9bb4] text-sm" data-id="element-74">{item.desc}</p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="mt-12 p-6 bg-[#c9956b]/10 rounded-xl border border-[#c9956b]/20 text-center" data-id="element-75">
          <h4 className="font-bold text-[#c9956b] mb-2" data-id="element-76">
            Lo que puede cambiar (sin prometer milagros)
          </h4>
          <p className="text-[#f0e6d3]/90 italic" data-id="element-77">
            "No te voy a vender 'desaparece la ansiedad'. Lo que sí pasa es:
            menos pelea, menos negociación y más sensación de 'ya terminé por
            hoy'."
          </p>
        </motion.div>
      </div>
    </section>;
}